module.exports = __webpack_public_path__ + "img/law.9821220d.jpg";